import { formatDate } from '@/utils/dateHelper';
import { pagingWithResults } from '@/constants/states';
import { readStates, saveStates } from '@/constants/lifecycle';
import { announcementStates } from '../announcements/constants';

export const newNotificationsList = (code, event) => ({
  code,
  name: null,
  event,
  ...pagingWithResults(),
  ...readStates,
  filter: '',
});

export const activeNotification = () => ({
  open: false,
  code: null,
  category: null,
  event: null,
  notification: {
    author: { name: null },
    createdOn: null,
    description: null,
    name: null,
  },
});

const initialState = {
  activeNotification: activeNotification(),
  announcements: {
    all: {
      ...announcementStates,
      results: [],
      open: false,
      count: undefined,
      currentIndex: 0,
      closeTimeStamp: 0,
      hideForSession: undefined,
    },
  },
  notifications: {
    dataset: { results: [] },
  },
  subscribers: {
    dataset: { results: [] },
  },
  subscriptions: {
    open: false,
    ...readStates,
    ...saveStates,
    results: [],
  },
};

export const notificationsStateToLoad = (state, isHideForSession) => (
  {
    ...initialState,
    announcements: {
      ...initialState.announcements,
      all: {
        ...initialState.announcements.all,
        closeTimeStamp: state.notifications.announcements.all.closeTimeStamp
                || initialState.announcements.all.closeTimeStamp,
        hideForSession: isHideForSession,
      },
    },
  }
);

export const notificationsStateToSave = ({ notifications }) => (
  {
    notifications: {
      announcements: {
        all: {
          closeTimeStamp: notifications.announcements.all.closeTimeStamp,
        },
      },
    },
  }
);

export const notificationsSessionStateToSave = ({ notifications }) => (
  {
    notifications: {
      announcements: {
        all: {
          hideForSession: notifications.announcements.all.hideForSession,
        },
      },
    },
  }
);

export const notificationsResult = (result) => ({
  createdOn: result.created_at ? formatDate(result.created_at) : '',
  ...result,
});

export default initialState;
